import React from 'react';
import { Link } from 'react-router-dom';

export default function SectionsDocs({ topic, setTopic, userInfo, schoolType }) {
	const isSupervisor = userInfo && `${userInfo.role_id}` === '3';
	const validTopics = ['search_sections', 'sort_sections', 'filter_by_department', 'add_section', 'edit_section', 'delete_section', 'lock_unlock_section', 'view_section_details'].filter(topic_option => !isSupervisor || topic_option !== 'add_section');
	const sectionsTopic = validTopics.includes(topic) ? topic : 'default';

	const chooseSectionsTopic = (newTopic) => {
		if (sectionsTopic === newTopic) {
			setTopic(null);
		} else {
			setTopic(newTopic);
		}
	};

	const videoPlaceholder = { backgroundColor: '#000', borderRadius: '8px', color: '#fff', minHeight: '240px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '20px', padding: '20px', textAlign: 'center' };

	return (
		<div className='documentation-page'>
			<div className='step-main-heading'>Sections</div>
			<p className='documentation-question-heading'>What do you need help with?</p>
			<div className='choose-topic'>
				<Link className={`choose-topic-btn ${sectionsTopic === 'search_sections' ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/scheduling_data/sections/${sectionsTopic === 'search_sections' ? 'null' : 'search_sections'}`} onClick={() => chooseSectionsTopic('search_sections')}>Search Sections</Link>
				<Link className={`choose-topic-btn ${sectionsTopic === 'sort_sections' ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/scheduling_data/sections/${sectionsTopic === 'sort_sections' ? 'null' : 'sort_sections'}`} onClick={() => chooseSectionsTopic('sort_sections')}>Sort Section Data</Link>
				<Link className={`choose-topic-btn ${sectionsTopic === 'filter_by_department' ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/scheduling_data/sections/${sectionsTopic === 'filter_by_department' ? 'null' : 'filter_by_department'}`} onClick={() => chooseSectionsTopic('filter_by_department')}>Filter By Department</Link>
				{!isSupervisor && <Link className={`choose-topic-btn ${sectionsTopic === 'add_section' ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/scheduling_data/sections/${sectionsTopic === 'add_section' ? 'null' : 'add_section'}`} onClick={() => chooseSectionsTopic('add_section')}>Add A Section</Link>}
				<Link className={`choose-topic-btn ${sectionsTopic === 'edit_section' ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/scheduling_data/sections/${sectionsTopic === 'edit_section' ? 'null' : 'edit_section'}`} onClick={() => chooseSectionsTopic('edit_section')}>Edit A Section</Link>
				<Link className={`choose-topic-btn ${sectionsTopic === 'delete_section' ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/scheduling_data/sections/${sectionsTopic === 'delete_section' ? 'null' : 'delete_section'}`} onClick={() => chooseSectionsTopic('delete_section')}>Delete A Section</Link>
				<Link className={`choose-topic-btn ${sectionsTopic === 'lock_unlock_section' ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/scheduling_data/sections/${sectionsTopic === 'lock_unlock_section' ? 'null' : 'lock_unlock_section'}`} onClick={() => chooseSectionsTopic('lock_unlock_section')}>Lock Or Unlock A Section</Link>
				<Link className={`choose-topic-btn ${sectionsTopic === 'view_section_details' ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/scheduling_data/sections/${sectionsTopic === 'view_section_details' ? 'null' : 'view_section_details'}`} onClick={() => chooseSectionsTopic('view_section_details')}>View Section Details</Link>
			</div>

			{sectionsTopic === 'search_sections' &&
				<div className='documentation-container'>
					<h2 className='documentation-page-heading'>Search Sections</h2>
					<div className='documentation-step-text'>Search sections by course code, course name, or teacher name.</div>
					<div style={videoPlaceholder}>Video tutorial coming soon!</div>
				</div>
			}
			{sectionsTopic === 'sort_sections' &&
				<div className='documentation-container'>
					<h2 className='documentation-page-heading'>Sort Section Data</h2>
					<div className='documentation-step-text'>Sort the section list by Course Code or Course name.</div>
					<div style={videoPlaceholder}>Video tutorial coming soon!</div>
				</div>
			}
			{sectionsTopic === 'filter_by_department' &&
				<div className='documentation-container'>
					<h2 className='documentation-page-heading'>Filter By Department</h2>
					<div className='documentation-step-text'>Filter sections to specific departments from the header filter.</div>
					<div style={videoPlaceholder}>Video tutorial coming soon!</div>
				</div>
			}
			{sectionsTopic === 'add_section' &&
				<div className='documentation-container'>
					<h2 className='documentation-page-heading'>Add A Section</h2>
					<div className='documentation-step-text'>Use the plus button to create a new section from this screen.</div>
					<div style={videoPlaceholder}>Video tutorial coming soon!</div>
				</div>
			}
			{sectionsTopic === 'edit_section' &&
				<div className='documentation-container'>
					<h2 className='documentation-page-heading'>Edit A Section</h2>
					<div className='documentation-step-text'>Use the edit icon on a row to open the section editor.</div>
					<div style={videoPlaceholder}>Video tutorial coming soon!</div>
				</div>
			}
			{sectionsTopic === 'delete_section' &&
				<div className='documentation-container'>
					<h2 className='documentation-page-heading'>Delete A Section</h2>
					<div className='documentation-step-text'>Use the delete icon and confirm to permanently remove a section.</div>
					<div style={videoPlaceholder}>Video tutorial coming soon!</div>
				</div>
			}
			{sectionsTopic === 'lock_unlock_section' &&
				<div className='documentation-container'>
					<h2 className='documentation-page-heading'>Lock Or Unlock A Section</h2>
					<div className='documentation-step-text'>Use the lock icon to prevent or allow section placement changes.</div>
					<div style={videoPlaceholder}>Video tutorial coming soon!</div>
				</div>
			}
			{sectionsTopic === 'view_section_details' &&
				<div className='documentation-container'>
					<h2 className='documentation-page-heading'>View Section Details</h2>
					<div className='documentation-step-text'>Review section number, periods, classroom, student count, and subsection or inclusion labels.</div>
					<div style={videoPlaceholder}>Video tutorial coming soon!</div>
				</div>
			}
		</div>
	);
}
